import { useEffect, useState } from "react";
import { Download } from "lucide-react";

export default function PwaInstallButton({ resident = false }) {
    const [prompt, setPrompt] = useState(null);
    const [installed, setInstalled] = useState(false);

    useEffect(() => {
        const manifest = document.getElementById("app-manifest");
        if (manifest) manifest.href = resident ? "/manifest-resident.json" : "/manifest-owner.json";
        const onBeforeInstall = (event) => {
            event.preventDefault();
            setPrompt(event);
        };
        const onInstalled = () => {
            setInstalled(true);
            setPrompt(null);
        };
        window.addEventListener("beforeinstallprompt", onBeforeInstall);
        window.addEventListener("appinstalled", onInstalled);
        return () => {
            window.removeEventListener("beforeinstallprompt", onBeforeInstall);
            window.removeEventListener("appinstalled", onInstalled);
        };
    }, [resident]);

    if (installed) return null;

    const install = async () => {
        if (prompt) {
            await prompt.prompt();
            await prompt.userChoice;
            setPrompt(null);
            return;
        }
        if (/iphone|ipad|ipod/i.test(navigator.userAgent)) {
            window.alert("Нажмите «Поделиться», затем «На экран Домой», чтобы установить приложение.");
        } else {
            window.alert("Откройте меню браузера и выберите «Установить приложение» или «Добавить на главный экран».");
        }
    };

    return (
        <button type="button" onClick={install}
                className="inline-flex items-center gap-2 px-3 py-2 rounded-lg text-xs"
                style={{ border: "1px solid var(--card-border)", color: "var(--foreground-2)" }}>
            <Download className="w-4 h-4" />
            {resident ? "Установить приложение жильца" : "Установить приложение владельца"}
        </button>
    );
}
